import React from "react";

import {XSpan, XTd, XTh, XTr, XI, XDiv, XLabel} from "../Layout/Layout";
import {renderModel} from "../AllModels";
import CheckBox from "../Input/CheckBox";

const TableManager  = {

    /**
     *
     * @param columns
     * @param ts
     * @param links
     */
    initCols(columns,ts,links=[]) {
        let i=0;
        let l=columns.length;
        for (i=0;i<l;i++){
            let col=columns[i];
            let obg={
                title: '',
                type: 'XSpan',
                id: null,
                key: null,
                width: null,
                isOrder:false,
                isLink:false,
                isState:false,
                props: [],
                other:{},
            };
            obg.title=col.title;
            if(col.hasOwnProperty('type')){
                obg.type=col.type;
            }
            if(col.hasOwnProperty('width')){
                obg.width=col.width;
            }
            if(col.hasOwnProperty('id')) {
                obg.id = col.id;
            }
            if(col.hasOwnProperty('key')) {
                obg.key = col.key;
            }
            if(col.hasOwnProperty('isOrder')) {
                obg.isOrder = col.isOrder;
            }
            if(col.hasOwnProperty('props')){
                obg.props=col.props;
            }
            if(col.hasOwnProperty('isLink')) {
                obg.isLink = col.isLink;
                if(obg.isLink){
                    obg.other["links"]=links;
                }
            }
            if(col.hasOwnProperty('isState')) {
                obg.isState = col.isState;
                if(obg.isState){
                    if(col.other.hasOwnProperty("enState")) {
                        obg.other["enState"] = col.other.enState;
                    }else{
                        obg.isState = false;
                    }
                }
            }

            ts.cols.push(obg);
            ts.hasCols=true;
        }
    },

    /**
     *
     * @param ts
     * @param orderColumn
     * @param orderDir
     * @param orderFun
     * @param selectFun
     */
    initHeads(ts,orderColumn=-1,orderDir=-1,orderFun=null,selectFun=null) {
        let i = 0;
        let l = ts.cols.length;
        for (i = 0; i < l; i++) {
            let obj = ts.cols[i];
            ts.keyHead++;
            let th = this.getTh(obj,i,ts.keyHead,orderColumn,orderDir,orderFun,selectFun,ts);
            ts.heads.push(th);
        }
    },

    /**
     *
     * @param ts
     * @param orderColumn
     * @param orderDir
     * @param orderFun
     * @param selectFun
     */
    initFoots(ts,orderColumn=-1,orderDir=-1,orderFun=null,selectFun=null) {
        let i = 0;
        let l = ts.cols.length;
        for (i = 0; i < l; i++) {
            let obj = ts.cols[i];
            ts.keyHead++;
            let th = this.getTh(obj,i,ts.keyHead,orderColumn,orderDir,orderFun,selectFun,ts);
            ts.foots.push(th);
        }
    },

    /**
     *
     * @param obj
     * @param i
     * @param key
     * @param orderColumn
     * @param orderDir
     * @param orderFun
     * @param selectFun
     * @returns {*}
     */
    getTh(obj,i,key,orderColumn=-1,orderDir=-1,orderFun=null,selectFun=null,ts=null) {
        let icon;
        let orderDirCell=1;
        if(obj.type==="SelectRow"){
            let r =React.createRef();
            if(ts != null ) ts.selectedCheckBox.push(r);
            return <XTh key={key} width={obj.width} ><CheckBox hasLabel={false}  ref={r} onChange={selectFun}/></XTh>;
        }else {
            let bOrder=false;
            if (obj.isOrder) {
                if(obj.id!=null){
                    bOrder=true;
                }
            }
            if (bOrder) {
                if (obj.id.toString() === orderColumn.toString()) {
                    if (orderDir.toString() === "1") {
                        icon = <XI className="sorting las la-sort-amount-down-alt"/>;
                    } else {
                        icon = <XI className="sorting las la-sort-amount-up"/>;
                    }
                    if(ts !=null)   ts.oldOrderColIndex=i;
                } else {
                    icon = <XI className=""/>;
                }
                orderDirCell = orderDir;
                return <XTh attrs={{colindex:i,ordercolumn: obj.id, orderdir: orderDirCell}} key={key} width={obj.width} onClick={orderFun}><XSpan>{obj.title}</XSpan>{icon}</XTh>;
            }else{
                return <XTh   key={key} width={obj.width}  ><XSpan>{obj.title}</XSpan>{icon}</XTh>;
            }

        }
    },

    /**
     *
     * @param children
     * @param ts
     */
    addRowChildren(children,ts) {
        React.Children.forEach(children,function (child) {
            ts.rowsId++;
            let el = React.cloneElement(child, {
                //closeItem:this.handleCloseItem,
                itemId: ts.rowsId,
                key: ts.rowsId,
            })
            ts.rows.push(el);
        });
    },

    /**
     *
     * @param data
     * @param ts
     * @param recordKeyName
     * @param selectFun
     */
    addData(data,ts,recordKeyName,selectFun=null) {
        ts.rows=[];
        let l=data.length;
        for (let i=0;i<l;i++){
            this.addRecordData(data[i],ts,data[i][recordKeyName],selectFun);
        }
    },

    /**
     *
     * @param record
     * @param ts
     * @param recordKey
     * @param selectFun
     */
    addRecordData(record,ts,recordKey,selectFun=null) {
        let tds=[];
        let i=0;
        let l=0;
        let v=null;
        if(ts.hasCols){
            l=ts.cols.length
            for (i = 0; i < l; i++) {
                let col=ts.cols[i];
                v=this.renderTd(record,col,ts,selectFun);
                let eltd = <XTd key={i} width={col.width}>{v}</XTd>;
                tds.push(eltd);
            }
        }else {
            l=record.length;
            for (i = 0; i < l; i++) {
                let eltd = <XTd key={i}>{record[i]}</XTd>;
                tds.push(eltd);
            }
        }
        ts.rowsId++;
        let el=<XTr  itemId={ts.rowsId} key={ts.rowsId} recordKey={recordKey}>{tds}</XTr>;

        ts.rows.push(el);
    },

    /**
     *
     * @param record
     * @param col
     * @param ts
     * @param selectFun
     * @returns {null}
     */
    renderTd(record,col,ts,selectFun=null) {
        let res=null;
        if(col.key!=null){
            if(col.isLink){
                if(col.other.hasOwnProperty("links")){
                    res = col.other["links"];
                }
            }else {
                if(col.type==="NumberRow") {
                    ts.rowsNumber++;
                    res = ts.rowsNumber;
                }else if(col.type==="SelectRow"){
                    res=<CheckBox className="checkbox-default selector" hasLabel={false} onChange={selectFun} />;
                }else {
                    if (record.hasOwnProperty(col.key)) {
                        let v = record[col.key];
                        if (v !== null) {
                            if(col.isState){
                                v=col.other.enState.getValueItem(v);
                            }
                            res = renderModel(col.type, v, col.props);
                        }
                    }
                }
            }
        }
        return res;
    },

    /**
     *
     * @param filters
     * @param ts
     * @param closeFun
     */
    initFilters(filters,ts,closeFun) {
        ts.filters=[];
        ts.filtersIndex=[];
        let i=0;
        for(var pn in filters) {
            i++;
            let el=<XDiv key={i} ><XLabel>{filters[pn].label}</XLabel><XSpan>{filters[pn].value}</XSpan>
                <XI className="la la-close" attrs={{filterid:i,pn:pn}} onClick={closeFun}/></XDiv>;
            ts.filters.push(el);
            ts.filtersIndex.push(i);
        }
    },


}



export default TableManager;
